import reducer from "./reducer";
export { default as Ratings } from "./components/index";
export { default as ratingsReducerName } from "./constants";
export default reducer;
